var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Inputmask from "inputmask";
export function createMaskTextFieldProvider(dotNetMaskTextFieldProvider) {
    return new MaskTextFieldProvider(dotNetMaskTextFieldProvider);
}
class MaskTextFieldProvider {
    constructor(dotNetMaskTextFieldProvider) {
        this.dotNetMaskTextFieldProvider = dotNetMaskTextFieldProvider;
    }
    initialize(maskTextFieldId, mask, regex) {
        return __awaiter(this, void 0, void 0, function* () {
            var selector = document.getElementById(maskTextFieldId);
            var im = new Inputmask({
                mask: mask,
                showMaskOnHover: false,
                regex: regex,
            });
            im.mask(selector);
        });
    }
}
